import React, { useEffect, useState } from 'react'
import closeIcon from "src/assets/images/close-ic.png";
import BOMImg from "src/assets/images/addtobom-icon.svg";
import dataSheetImg from "src/assets/images/datasheet-black.png";
import AddToCart from "../../component/custom/AddToCart";
import RefreshStockButton from "../ProductListing/RefreshStockButton";
import DisplayQtyMinQtyMult from "../../component/custom/DisplayQtyMinQtyMult";
import DisplayLifeCycleRisk from "../../component/custom/DisplayLifeCycleRisk";
import PriceTable from "../../component/custom/PriceTable";
import NavigateToProductDetail from "../../component/custom/NavigateToProductDetail";
import liveAuth from "src/helper/liveAuth";
import System from "../../helper/system";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import ProductLegends from "../ProductListing/ProductLegends";
import noImage from 'src/assets/images/noimage.png'
import { useCartStore } from "src/hooks/cart";
import useReduxState from "src/hooks/useReduxState";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import Constants from "src/helper/Constants";
import ReusableDiv from "src/helper/ReusableDiv";
import QuantityPicker from 'src/component/custom/QuantityPicker';
import { useProductStore } from 'src/hooks/product';
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';
import SpecialOffer from 'src/component/custom/SpecialOffer';
import Bom from "@system/config/bom";
import { useBOMStore } from 'src/hooks/bom';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import CustomerPartNumberOptions from 'src/component/custom/CustomerPartNumberOptions';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const CompareProductTable = ({ setShowError, setNoProductError }) => {
  const [{ model_ProductCompare_data }, { toggle_Single_Product, fetch_All_Data, get_product_assets }, { }] = useProductStore();
  const [productList, setProductList] = useReduxState({}, 'setProductList');
  const [products, SetProducts] = useState([]);
  const [manufacturer, Setmanufacturer] = useState([]);
  const [__check] = useAxiosIndicatorCheck();
  const [productInventoryList, setProductInventoryList] = useReduxState([], 'setProductInventoryList');
  const [structureHierarchyArray, setStructureHierarchyArray] = useState([]);
  const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
  const [attributes, setAttributes] = useState();
  const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
  const [isGetAssets, set_IsGetAssets] = useState(true);
  const orderBlock = System.avUserInfoData.orderBlock;
  // const [firstServerCall, setFirstServerCall] = useState(true);
  const [{ }, { }, { add_part_to_bom, create_bom, create_params_for_add_part_to_bom }] = useBOMStore();
  const [loadfetchInventoryFromServer, set_loadfetchInventoryFromServer] = useState(true);
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);

  useEffect(() => {
    async function fetchHere() {
      if (model_ProductCompare_data && Object.entries(model_ProductCompare_data).length > 0) {
        await setProductList(model_ProductCompare_data);
        if (isGetAssets) { // Note: When delete product - restrict inventory /pricing call
          const inventory = {};
          // setFirstServerCall(false)
          await get_product_assets(model_ProductCompare_data)
          set_loadfetchInventoryFromServer(false)

          setProductInventoryList(inventory)
        } else {
          set_IsGetAssets(true)
        }
      } else {
        setProductList({});
        if (!isGetAssets) {
          set_IsGetAssets(true)
          setNoProductError(true)
        }
      }

    }

    fetchHere();
  }, [model_ProductCompare_data]);

  useEffect(() => {
    async function fetchHere() {
      await getAllData();
    }
    fetchHere();
  }, [productList]);

  useEffect(() => {
    if (products.length > 0) {
      products.map((product) => {
        setStructureHierarchyArray((prevState) => [...prevState,
        { ItemRowNumber: product.ItemRowNumber, StructureHierarchy: product.StructureHierarchy, },
        ]);
      });
    }
  }, [products]);

  useEffect(() => {
    if (structureHierarchyArray.length > 1) {
      setShowError(!validateAllCatagories(structureHierarchyArray));
      setNoProductError(false);
    }
  }, [structureHierarchyArray, products]);



  function validateAllCatagories(array) {
    const arrayWithCatagories = [];

    if (array.length > 1) {
      array.map((item) =>
        !arrayWithCatagories.includes(item.StructureHierarchy) &&
        arrayWithCatagories.push(item.StructureHierarchy)
      );
    }

    return arrayWithCatagories.every((element) => {
      if (element === arrayWithCatagories[0]) {
        return true;
      }
    });
  }

  const deleteProduct = async (product) => {
    set_IsGetAssets(false);
    const structureHierarchyArrayWithoutRemovedItem = structureHierarchyArray.filter((item) => item.ItemRowNumber !== product.ItemRowNumber);
    setStructureHierarchyArray(structureHierarchyArrayWithoutRemovedItem);
    await toggle_Single_Product(product);
    await fetch_All_Data();
  };

  const getAttrKeys = () => {
    let keyAry = [];
    if (productList && Object.keys(productList).length > 0) {
      Object.keys(productList).map(
        (v, i) => {
          const attr = productList[v].Attributes.map(f => f.ATTRNAME)
          if (keyAry?.length > 0) {
            keyAry = keyAry.concat(attr)
          } else {
            keyAry = attr
          }
        })
    }

    keyAry = [...new Set(keyAry)];

    return keyAry;
  }

  const getAllData = async () => {
    if (productList && Object.keys(productList).length > 0) {
      setNoProductError(false)
      const productData = [];
      const manufacturerData = [];

      let keyAry = getAttrKeys();
      keyAry = keyAry.map(obj => ({ key: obj, value: [] }))

      Object.keys(productList).map(
        (v, i) => {
          productData.push({
            ...productList[v]
          })

          manufacturerData.push({
            ERPManufacturerName: productList[v].ManufacturerName ? productList[v].ManufacturerName : "",
          })

          keyAry.map((k, idx) => {
            const attr = productList[v].Attributes.find(f => f.ATTRNAME === k.key)?.ATTRVAL
            k.value.push(attr ? attr : "NA")
          });
        }
      );
      SetProducts(productData);

      Setmanufacturer(manufacturerData);
      setAttributes(keyAry);
      if (!monitorFunctionCall) {
        System.monitorFrameWorkReady()
        setMonitorFunctionCall(true)
      }
    }

  };

  const refreshStock = async () => {
    set_loadfetchInventoryFromServer(true)
    await get_product_assets(products, { isPriceCall: false })
    set_loadfetchInventoryFromServer(false)
  }

  const openAddToBOM = async (e) => {
    if (liveAuth.check()) {
      let _product = {
        ...e,
        QtyMin: CART_BEFORE_TO_SEND_SERVER[e.ItemNumber]?.quantityUpdateToCart || e.QtyMin
      };
      System.popup('AddToBOMPopup', {
        single_product: _product, addFrom: 'Compare', single_product_pricing_list: get_pricing_by_id({
          ItemNumber: _product.ItemNumber
        })
      })

    } else {
      const guestBomID = localStorage.getItem(System.storageName.GUEST_BOM_ID)
      const params = await create_params_for_add_part_to_bom(e)

      if (guestBomID) {
        const addPart = await add_part_to_bom(params)
        if (addPart?.data) {
          redirectToBOM(guestBomID);
        }
      } else {
        params.source = Constants.systemModules.COMPARE
        const newBom = await create_bom(params);
        if (newBom?.data) {
          redirectToBOM(newBom.data);
        }
      }
    }

  };

  const redirectToBOM = (bomId) => {
    window.location.href = Bom.getBomDetailByIdRouteURL(
      bomId,
      {
        go: System.getParams().go
      }
    )
  };

  const getGuestDisplayTooltipButton = (v) => {
    return <>
      <a href={void 0} className="img-text" onClick={() => openAddToBOM(v)}>
        <img src={BOMImg} />
        <span className="blue text">Add To BOM</span>
      </a>
    </>
  };

  return (
    <>
      <div className="table-responsive">
        {productList && Object.keys(productList).length > 0 &&
          (
            <table className="copmare-product-table table table-bordered table-striped">
              <thead>
                <tr>
                  <th colSpan={8}>PRODUCTS</th>
                </tr>
                <tr className="white-bg">
                  {products.map((v, i) => (
                    <td key={i} className="align-top">
                      <div className="compare-product-detail">
                        <div className="compare-product-title">
                          <NavigateToProductDetail data={{ SEOManufacturerName: v?.SEOManufacturerName, SEOERPMFRPartNumber: v?.SEOERPMFRPartNumber, ItemNumber: v?.ItemNumber, ERPPartNumber: v?.ERPPartNumber }}>
                            {v.ERPMFRPartNumber}
                          </NavigateToProductDetail>
                          <div className="close-ic"
                            onClick={async () => {
                              await deleteProduct(v)
                            }}
                          >

                            <img src={closeIcon} />
                          </div>
                        </div>
                        <div className="copmare-product-info">
                          <div className="product-img text-center ">
                            <img
                              src={v.AssetURL ? v.AssetURL : noImage} />
                          </div>

                          <div className="sect-row">{getGuestDisplayTooltipButton(v)}
                            {(v.DatasheetUrl) ? (
                              <div className="datasheet">
                                <a className="datasheet-align img-text" rel="nofollow"
                                  href={v.DatasheetUrl}
                                  title={
                                    v.ManufacturerPartNumber + " Datasheet"
                                  }
                                  target="_new">
                                  <img src={dataSheetImg} />
                                  <span className="blue text">Datasheet</span>
                                </a>
                              </div>
                            ) :
                              ReusableDiv.dataSheetTooltip()
                            }

                            <DisplayLifeCycleRisk single_product={v} compare={true} />
                          </div>
                        </div>
                        {loadfetchInventoryFromServer ?
                          <AxiosIndicatorRunTimeLoader /> :
                          v.ERPPartNumber !== "" && v.ERPPartNumber !== " " && v.ERPPartNumber !== null && (
                            <div className="col-auto p-0 copmare-product-add-remove">
                              <SpecialOffer single_product={v} single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })}
                                single_product_inventory={get_inventory_by_id(v.ItemNumber)} />
                              <div className="text-left small-text light light-text collapse_minmax">
                                <DisplayQtyMinQtyMult single_product={v} />
                              </div>
                              <div>
                                <QuantityPicker
                                  single_product={v}
                                  single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                                  single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })}
                                />
                              </div>
                              <div>
                                <AddToCart
                                  single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })}
                                  single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                                  single_product={v}
                                  isFrom="Compare"
                                />
                              </div>
                            </div>
                          )
                        }

                      </div>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={8}>
                    <b>Manufacturer</b>
                  </td>
                </tr>
                <tr className="white-bg">
                  {manufacturer.map((v, i) => (
                    <td key={i}>
                      {v.ERPManufacturerName}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td colSpan={8}>
                    <b>Customer Part Number</b>
                  </td>
                </tr>
                <tr className="white-bg">
                  {products.map((v, i) =>
                    <td key={i}>
                      <CustomerPartNumberOptions
                        // single_product_inventory={single_product_inventory}
                        single_product={v}
                      // updationStartedCallback={() => {
                      //   set_visibility_state(false)
                      // }}
                      // updationCompletedCallback={() => {
                      //   set_visibility_state(true)
                      // }}
                      // single_product_pricing_list={single_product_pricing_list}
                      // displayManualCpn={false}
                      />
                    </td>
                  )}

                </tr>
                <tr>
                  <td colSpan={8}>
                    <b> Availability</b>
                    <RefreshStockButton
                      fetchInventoryFromServer={refreshStock}
                      label={'Refresh Stock'}
                    />
                  </td>
                </tr>
                <tr className="white-bg">
                  {products.map((v, i) => (
                    <td key={i}>
                      {loadfetchInventoryFromServer ?
                        <AxiosIndicatorRunTimeLoader /> :
                        <ProductInventoryDisplay single_product={v} single_product_inventory={get_inventory_by_id(v.ItemNumber)} position={'top left'} />
                      }
                    </td>
                  ))}
                </tr>
                {!orderBlock &&
                  <tr>
                    <td colSpan={8}>
                      <b>Price</b>
                    </td>
                  </tr>
                }

                <tr className="white-bg compared-product-price">
                  {products.map((v, i) =>
                    <td key={i}>
                      <PriceTable
                        linesToDisplay={100}
                        single_product={v}
                        single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                        single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })}
                      />
                    </td>
                  )}
                </tr>

                <tr>
                  <td colSpan={8}>
                    <b>Information</b>
                  </td>
                </tr>
                <tr className="white-bg">
                  {products.map((v, i) => (
                    <td key={i} className="pb-0">
                      <ul className="list-text list-text-inline d-flex flex-wrap">
                        <ProductLegends single_product={v} onlyIconTitle={true} />
                      </ul>
                    </td>
                  ))}
                </tr>

                {attributes && attributes.length > 0 &&
                  attributes.map((v) => (
                    <React.Fragment key={v.key}>
                      <tr>
                        <td colSpan={8}>
                          <b> {v.key} </b>
                        </td>
                      </tr>
                      <tr className="white-bg">
                        {v.value.map((k, idx) => (
                          <td key={idx}>{k}</td>
                        ))}
                      </tr>
                    </React.Fragment>
                  ))
                }

              </tbody>
            </table>
          )}
      </div>
    </>
  );
};

export default CompareProductTable;
